import React from "react";
import styles from "./service-request-header.module.scss";

interface ServiceRequestHeaderProps {
	tagName: string;
	sectionTitle: string;
	description: string;
}

const ServiceRequestHeader: React.FC<ServiceRequestHeaderProps> = ({ tagName, sectionTitle, description }) => {
	return (
		<div className={styles.header}>
			<div className={styles.row}>
				<div className={styles.left}>
					<span className={styles.tag}>{tagName}</span>
					<span className={styles.title}>{sectionTitle}</span>
				</div>
				{description && (
					<>
						<span className={styles.verticalDivider} />
						<p className={styles.description}>{description}</p>
					</>
				)}
			</div>
		</div>
	);
};

export default ServiceRequestHeader;
